module.exports = __webpack_public_path__ + "img/blood.2a6ab6dc.png";